<ng-container [formGroup]="group()"
              cdkDropListGroup>

  <label [for]="id + '-tag'" i18n>Tag:</label>
  <div class="form-array">
    <input [id]="id + '-tag'" name="tag" type="text" formControlName="tag">
    @if (showClear()) {
      <button type="button" (click)="clear.emit()" i18n-title title="New Ext" i18n>🆑️</button>
    }
  </div>

  <label [for]="id + '-name'" i18n>Name:</label>
  <input [id]="id + '-name'" name="name" type="text" formControlName="name">

  <ng-container [formGroup]="config()">
    @if (userTheme() && userThemeValues().length) {
      <!-- TODO: replace empty themes with instructions -->
      <label [for]="id + '-userTheme'" i18n>User Theme:</label>
      <div i18n-title title="This theme will be used on every page. Tag page themes will be ignored.">
        <select [id]="id + '-userTheme'" formControlName="userTheme">
          <option [ngValue]="undefined" i18n>default</option>
          @for (t of userThemeValues(); track t) {
            <option [ngValue]="t">{{ t }}</option>
          }
        </select>
      </div>
    }
    @if (defaultSort() && !user()) {
      <label [for]="id + '-defaultSort'" i18n>Default Sort:</label>
      <div class="default-sort bubble">
        <select #defaultSortCreate
                class="default-sort-create"
                [id]="id + '-defaultSort'"
                (input)="addSort($any($event.target).value, defaultSortCreate)">
          <option i18n>+ Add sort</option>
          @for (opt of allSorts(); track opt) {
            <option [value]="opt.value">{{ opt.label || opt.value }}</option>
          }
        </select>
        @for (sort of defaultSortValue(); track $index; let i = $index) {
          <span class="controls default-sort-row">
            <select [id]="id + '-defaultSort-' + i"
                    (input)="setSortCol(i, $any($event.target).value)">
              @for (opt of allSorts(); track opt) {
                <option [value]="opt.value" [selected]="opt.value === sortCol(sort)">{{ opt.label || opt.value }}</option>
              }
            </select>
            @if (sortDir(sort) === "DESC") {
              <button type="button" (click)="setSortDir(i, 'ASC')" i18n-title title="Descending" i18n>🔽️</button>
            } @else {
              <button type="button" (click)="setSortDir(i, 'DESC')" i18n-title title="Ascending" i18n>🔼️</button>
            }
            <button type="button" (click)="removeSort(i)" i18n>&ndash;</button>
          </span>
        }
      </div>
    }
    @if (defaultFilter() && !user()) {
      <label [for]="id + '-defaultFilter'" i18n>Default Filter:</label>
      <div class="default-filter bubble">
        <select #defaultFilterCreate
                class="default-filter-create"
                [id]="id + '-defaultFilter'"
                (input)="addFilter($any($event.target).value, defaultFilterCreate)">
          <option i18n>+ Add filter</option>
          @for (opt of allFilters(); track opt) {
            <option [value]="opt.filter">{{ opt.label || opt.filter }}</option>
          }
        </select>
        @for (filter of defaultFilterValue(); track $index; let i = $index) {
          <div class="default-filter-row">
            <span class="controls">
              <select [id]="id + '-defaultFilter-' + i"
                      (input)="setFilter(i, switchFilter(filter, $any($event.target).value))">
                @if (!hasFilterOption(filter)) {
                  <option [value]="filter" selected>{{ filterOptionLabel(filter) }}</option>
                }
                @for (opt of allFilters(); track opt) {
                  <option [value]="opt.filter" [selected]="opt.filter === filterOption(filter)">{{ opt.label || opt.filter }}</option>
                }
              </select>
              @if (negatable(filter)) {
                <button class="default-filter-negate" type="button" (click)="toggleFilter(i)">{{ store.account.querySymbol('!') }}</button>
              }
              <button type="button" (click)="removeFilter(i)" i18n>&ndash;</button>
            </span>
            @if (filterIsDate(filter)) {
              @if (store.hotkey() || filterSpecialDate(filter)) {
                <app-relative-date class="default-filter-date-range"
                                   [value]="filterDateValue(filter)"
                                   (changed)="setFilterDatePreset(i, filter, $event)" />
              } @else {
                <input type="datetime-local"
                       step="60"
                       [value]="filterDate(filter)"
                       (change)="setFilterDate(i, filter, $any($event.target).value)">
              }
            } @else if (parseValueFilter(filter)) {
              <app-value-filter [filter]="filter" [query]="ext()?.tag || ''" (changed)="setFilterValue(i, filter, $event)" />
            }
          </div>
        }
      </div>
    }
    @if (form(); as form) {
      <formly-form class="nested-form"
                   [form]="config()"
                   [model]="model()"
                   [fields]="form"
                   [options]="options" />
    }
    @if (modmail() && inbox() && !user()) {
      <label [for]="id + '-modmail'" i18n>Enable Modmail:</label>
      <div>
        <input [id]="id + '-modmail'" type="checkbox" [formControl]="modmail()">
        <a class="tag" [routerLink]="['/tag', inbox()]">{{ inbox() }}</a>
      </div>
    }
    @if (themes()) {
      <label [for]="id + '-theme'" i18n>Tag Page Theme:</label>
      <div>
        <select [id]="id + '-theme'" formControlName="theme">
          <option [ngValue]="undefined" i18n>default</option>
          @for (t of themeValues(); track t) {
            <option [ngValue]="t">{{ t }}</option>
          }
        </select>
        <details class="advanced mini">
          <summary i18n-title title="Custom Themes"><span><span class="summary-open" i18n>Custom Themes</span></span></summary>
          <app-themes id="themes"
                      [group]="config()"
                      fieldName="themes" />
        </details>
      </div>
    }
  </ng-container>

  @if (advancedForm()?.length) {
    <details class="advanced">
      <summary><span i18n>Advanced</span></summary>
      <div class="form">
        @if (defaultSort() && user()) {
          <label [for]="id + '-defaultSortAdvanced'" i18n>Default Sort:</label>
          <div class="default-sort bubble">
            <select #defaultSortAdvancedCreate
                    class="default-sort-create"
                    [id]="id + '-defaultSortAdvanced'"
                    (input)="addSort($any($event.target).value, defaultSortAdvancedCreate)">
              <option i18n>+ Add sort</option>
              @for (opt of allSorts(); track opt) {
                <option [value]="opt.value">{{ opt.label || opt.value }}</option>
              }
            </select>
            @for (sort of defaultSortValue(); track $index; let i = $index) {
              <span class="controls default-sort-row">
                <select (input)="setSortCol(i, $any($event.target).value)">
                  @for (opt of allSorts(); track opt) {
                    <option [value]="opt.value" [selected]="opt.value === sortCol(sort)">{{ opt.label || opt.value }}</option>
                  }
                </select>
                @if (sortDir(sort) === "DESC") {
                  <button type="button" (click)="setSortDir(i, 'ASC')" i18n-title title="Descending" i18n>🔽️</button>
                } @else {
                  <button type="button" (click)="setSortDir(i, 'DESC')" i18n-title title="Ascending" i18n>🔼️</button>
                }
                <button type="button" (click)="removeSort(i)" i18n>&ndash;</button>
              </span>
            }
          </div>
        }
        <formly-form class="nested-form"
                     [form]="config()"
                     [model]="model()"
                     [fields]="advancedForm()!"
                     [options]="options" />
      </div>
      @if (defaults()) {
        <app-ref class="bubble" [ref]="defaults()" />
      } @else if (loadingDefaults()) {
        <app-loading />
      }
    </details>
  }
</ng-container>
